import { render, staticRenderFns } from "./MessageContentQuickReply.vue?vue&type=template&id=0193532f&scoped=true"
import script from "./MessageContentQuickReply.vue?vue&type=script&lang=js"
export * from "./MessageContentQuickReply.vue?vue&type=script&lang=js"
import style0 from "./MessageContentQuickReply.vue?vue&type=style&index=0&id=0193532f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0193532f",
  null
  
)

export default component.exports